/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { LabelDetailsDto } from '../../models/label-details-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface AddMarketLanguageProductTypeLabel$Params {
  /**
   * Market country code
   */
  market: string;

  /**
   * Market language code
   */
  language: string;

  /**
   * Product type
   */
  productType: 'CONFIGURATOR' | 'ONLINE_SHOP' | 'PRODUCT_PAGE' | 'TEST_DRIVE';
  body: LabelDetailsDto;
}

export function addMarketLanguageProductTypeLabel(
  http: HttpClient,
  rootUrl: string,
  params: AddMarketLanguageProductTypeLabel$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addMarketLanguageProductTypeLabel.PATH, 'put');
  if (params) {
    rb.path('market', params.market, {});
    rb.path('language', params.language, {});
    rb.path('productType', params.productType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addMarketLanguageProductTypeLabel.PATH = '/admin/labels/{market}/{language}/product-types/{productType}';
